import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-tree-add-btn-child',
  templateUrl: './tree-add-btn-child.component.html',
  styleUrls: ['./tree-add-btn-child.component.css']
})
export class TreeAddBTNChildComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input() Primary:number=0;
  @Input() Text:string='';

}
